<app-loader></app-loader>
<div class="customn-credit-model">
    <div class="credit-heading">
        <h4>Custom Credit</h4>
        <div (click)="closeDialog()" class="close-icon">
            <img src="../../../../assets/images/export-close.svg" alt="Close"/>
        </div>
    </div>

    <div class="select-outer">
        <p class="select-text">Selected</p>
        <div class="grey-bg">
            <div class="name-outer common-text">
                <img [src]="userData?.profileImagePath || dummy" alt="Profile"/>
                <div class="name-outer">
                    <h5>Name</h5>
                    <p>{{userData?.name}}</p>
                </div>
            </div>
            <div class="email-outer common-text">
                <h5>Email</h5>
                <p>{{userData?.email || '-'}}</p>
            </div>
            <div class="mobile-outer common-text">
                <h5>Mobile Number</h5>
                <p><span [ngClass]="getFlagClass(userData?.iso)"></span><span>{{userData?.countryCode}}
                        {{userData?.phoneNumber || userData?.mobileNumber || '-'}}</span></p>
            </div>
        </div>
    </div>

    <form [formGroup]="creditForm" (ngSubmit)="onSubmit()">
        <div  class="credit-outer" [ngClass]="{'superadmin-company' : isSuperAdmin}">
            <div *ngIf="isSuperAdmin" class="credit-input company-filter">
                <label for="companyId">Company <span class="custom-star">*</span></label>
                <div class="select-rate custom-dropdown">
                    <p-dropdown id="companyId" [options]="companyList" formControlName="companyId" optionValue="id" optionLabel="name" placeholder="Select Company"></p-dropdown>
                    <img src="assets/images/fill-dropdown.svg" alt="" />
                  </div>
                  <div *ngIf="creditForm.get('companyId')?.invalid && creditForm.get('companyId')?.touched">
                    <div class="validation-error">This field is required*</div>
                </div>
            </div>
            <div class="credit-input">
                <label for="credit">Credits <span class="custom-star">*</span></label>
                <input id="credit" type="text" formControlName="credit" (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" pInputText placeholder="Enter Credits Points" />
                <div *ngIf="creditForm.get('credit')?.touched">
                    <div *ngIf="creditForm.get('credit')?.hasError('required')" class="validation-error">
                        This field is required*
                    </div>
                    <div *ngIf="!creditForm.get('credit')?.hasError('required') && creditForm.get('credit')?.hasError('lessThanZero')" class="validation-error">
                        Credits must be greater than zero*
                    </div>
                    <div *ngIf="creditForm.get('credit')?.hasError('max')" class="validation-error">
                        Credits must not exceed 9999*
                    </div>
                </div>
            </div>

<div class="credit-note">
                <h5>Note</h5>
                <p>(Only able to use in Trucklots while making the booking also<br /> 1 credit is equal to 1 USD)</p>
            </div>
        </div>

        <div class="credit-input">
            <label for="reason">Reason <span class="custom-star">*</span></label>
            <textarea id="reason" formControlName="reason" maxlength="512" placeholder="Enter Reason" pTextarea></textarea>
            <div *ngIf="creditForm.get('reason')?.touched || creditForm.get('reason')?.dirty">
                <div *ngIf="creditForm.get('reason')?.hasError('required')" class="validation-error">
                  This field is required*
                </div>
                <div *ngIf="!creditForm.get('reason')?.hasError('required') && creditForm.get('reason')?.hasError('minlength')" class="validation-error">
                  Minimum 3 characters required
                </div>
              </div>
        </div>

        <div class="confirm-btn">
            <p-button type="submit" label="Confirm"></p-button>
        </div>
    </form>
</div>